import React, { useEffect, useState } from 'react'
import { GetServerSideProps } from 'next'
import { Loader, Modal } from '@mantine/core'
import { useDebounce } from '@uidotdev/usehooks'
import useStyles from './MaskModal.styles'
import {
  DEBUG_MODE,
  PRACTICAL_STREAM_LOGO_LARGE_DARK_PNG,
  PRACTICAL_STREAM_LOGO_LARGE_DARK_AVIF,
} from '../../utilities/config'

export default function MaskModal(props: any) {
  const { classes } = useStyles()
  const width: any = props?.width
  const height: any = props?.height
  const [resizing, setResizing] = useState<boolean>(true)
  const resizingDebounced: boolean = useDebounce(resizing, 200)
  const [layoutShiftDelayMet, setLayoutShiftDelayMet] = useState<boolean>(false)

  useEffect(() => {
    let timeoutId: NodeJS.Timeout | null = null
    try {
      timeoutId = setTimeout(() => setLayoutShiftDelayMet(true), 500)
    } catch (e) {
      if (DEBUG_MODE) console.log(e)
    }
    return () => {
      try {
        if (timeoutId != null) clearTimeout(timeoutId)
      } catch {}
    }
  }, [])

  useEffect(() => {
    let timeoutId: NodeJS.Timeout | null = null
    try {
      setResizing(true)
      timeoutId = setTimeout(() => setResizing(false), 300)
    } catch (e) {
      if (DEBUG_MODE) console.log(e)
    }
    return () => {
      try {
        if (timeoutId != null) clearTimeout(timeoutId)
      } catch {}
    }
  }, [height, width])

  return (
    <Modal
      styles={() => ({
        inner: {
          overflowX: 'hidden',
        },
        close: {
          display: 'none',
        },
        root: {
          backgroundColor: '#000000',
        },
        body: {
          backgroundColor: '#000000',
        },
        modal: {
          backgroundColor: '#000000',
        },
      })}
      style={{
        zIndex: 932043093,
        top: 0,
        backgroundColor: '#000000',
        height: '100vh',
        width: '100vw',
      }}
      onClose={() => {
        try {
          props?.setOpened(false)
        } catch (e) {
          if (DEBUG_MODE) console.log(e)
        }
      }}
      opened={props?.opened}
      withCloseButton={false}
      closeOnClickOutside={false}
      closeOnEscape={false}
      lockScroll={true}
      title=""
      fullScreen={true}
      className={classes.maskModal}
      overlayColor={'#ffffff'}
      overlayOpacity={0}
      overlayBlur={3}
      transition="fade"
    >
      <div style={{ visibility: !layoutShiftDelayMet ? 'hidden' : 'visible' }}>
        {resizingDebounced == false && (
          <div
            style={{
              display: 'flex',
              position: 'fixed',
              left: '50%',
              top: '70%',
              marginTop:
                width > 1000 && height > 800
                  ? '-20px'
                  : height < 475
                  ? '0px'
                  : height > 750
                  ? '-105px'
                  : '-50px',
              transform: 'translate(-50%, -45%)',
              bottom: '15',
              zIndex: 1,
              alignItems: 'center',
              justifyContent: 'center',
              flexDirection: 'column',
            }}
          ></div>
        )}

        <div
          style={{
            height:
              height > 339 && height < 1000 && width > 800 ? '50px' : '100px',
            width: '250px',
            left: '50%',
            top: '50%',
            transform:
              height < 475
                ? 'translate(-125px, -75px)'
                : height > 750
                ? 'translate(-125px, -225px)'
                : 'translate(-125px, -175px)',
            position: 'fixed',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'column',
          }}
        >
          {/* <FadeIn
            delay={10}
            transitionDuration={2000}
            className={classes.fadeInBackToTop}
          > */}
          <img
            alt=""
            style={{
              visibility: 'visible',
              maxHeight:
                width < 991
                  ? width > height
                    ? '20vh'
                    : height > 800 && width < 600
                    ? '7vh'
                    : '10vh'
                  : '19vh',
              height:
                width < 400
                  ? 'initial'
                  : width < 991
                  ? width > height
                    ? '20vh'
                    : height > 800 && width < 600
                    ? '7vh'
                    : '10vh'
                  : '19vh',
            }}
            className={classes.banner}
            draggable="false"
            src={
              !props?.avifCompatible || props?.isMacOsSafariLimitedRender
                ? PRACTICAL_STREAM_LOGO_LARGE_DARK_PNG
                : PRACTICAL_STREAM_LOGO_LARGE_DARK_AVIF
            }
            //@ts-ignore
            nopin="nopin"
            referrerPolicy="no-referrer"
          />
          <div
            style={{
              display: 'flex',
              marginTop: '25px',
              visibility: 'hidden',
              width: '100%',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <Loader
              variant={'dots'}
              height={height < 475 ? 30 : 60}
              width={height < 475 ? 30 : 60}
            />
          </div>
        </div>
      </div>
    </Modal>
  )
}

export const getServerSideProps: GetServerSideProps = async ({}) => {
  return {
    props: {},
  }
}
